/* Field & Fortune – colour dots on product cards: swap the card to another colour in place. */
(function () {
  if (window.FFColourCards) return;
  window.FFColourCards = true;

  document.addEventListener('click', function (event) {
    var dot = event.target.closest && event.target.closest('.ff-dot[data-ff-url]');
    if (!dot) return;
    var card = dot.closest('.card-wrapper');
    if (!card) return;
    if (dot.classList.contains('is-current')) {
      event.preventDefault();
      return;
    }
    event.preventDefault();

    var url = dot.dataset.ffUrl;
    // primary image (first <img> in the media block); hide the hover image, it belongs to the old colour
    var imgs = card.querySelectorAll('.card__media img');
    if (imgs[0] && dot.dataset.ffImg) {
      imgs[0].src = dot.dataset.ffImg;
      if (dot.dataset.ffSrcset) imgs[0].srcset = dot.dataset.ffSrcset;
      imgs[0].alt = '';
    }
    if (imgs[1]) imgs[1].style.display = 'none';

    // links (title + standard card link) and quick-add product url
    card.querySelectorAll('a.full-unstyled-link, a.card__link').forEach(function (a) {
      a.href = url;
    });
    card.querySelectorAll('[data-product-url]').forEach(function (el) {
      el.dataset.productUrl = url;
    });
    // single-variant quick add form (product without sizes)
    card.querySelectorAll('form input[name="id"]').forEach(function (input) {
      input.value = dot.dataset.ffVariant;
    });

    var label = card.querySelector('.ff-card-colour');
    if (label) label.textContent = dot.dataset.ffColour;

    card.querySelectorAll('.ff-dot').forEach(function (d) {
      d.classList.toggle('is-current', d === dot);
      if (d === dot) d.setAttribute('aria-current', 'true');
      else d.removeAttribute('aria-current');
    });
  });
})();
